import React from 'react';
import { domain } from '../../common/config.js';
import { saveActivity } from '../../common/commonService';
import { partyBrands } from '../../common/config.js';
import QuickQuiz from './QuickQuiz';
import { getColor, getTextColor } from '../../common/ThemeService.js';

const baseUrl = "//" + domain;
const WhizHelmet = "/LandingPage/Whiz_Helmet.png";
const images = {
    mistake: {
        header: "What are the most common poker mistakes? ",
        imagePath: "/images/pokerMistakes/",
        imagesAndData: [
            {
                image: '1.png',
                dataHeader: 'Playing too High',
                data: "You should never put more than 5% in play at any one time. Bankroll Management is a critical part of poker."

            }, {
                image: '2.png',
                dataHeader: 'Playing too Many Hands',
                data: "Do not be afraid to fold! Don't fall in love with your hand, some times folding is the best option."

            }, {
                image: '3.png',
                dataHeader: 'Not taking time to Learn',
                data: "Most beginners get so absorbed playing that they forget to think about how to improve their game. Play, analyse & learn. Use your Poker Report Card, it will show you the weaknesses in your play."

            }, {
                image: '4.png',
                dataHeader: 'Getting Emotional.',
                data: " Almost no player can play well when they are not calm, so if you feel yourself getting upset or angry take a break. Avoid Tilt."

            }, {
                image: '5.png',
                dataHeader: 'Being Too Passive',
                data: "Be the aggressor, don't be passive. If you enter a pot generally you should be raising."

            }, {
                image: '6.png',
                dataHeader: 'Not being Observant',
                data: "Most beginners focus on their own hands and do not pay enough attention to the other players."

            }, {
                image: '7.png',
                dataHeader: 'Unclear Why they are Betting',
                data: "Know why you are betting. A lot of beginners make bets without a clear intention behind the decision to bet. Almost all betting decisions can be broken down into 2 categories. To make a better hand fold, or to make a worse hand call. Know which one you are trying to do!"
            }, {
                image: '8.png',
                dataHeader: 'Lack of Patience & Discipline',
                data: "Be patient and bide your time, wait for the right opportunities in which to act. Tight is right! If you are bored folding all the time, open an additional table."

            }, {
                image: '9.png',
                dataHeader: "Don't be the Sheriff, a lot of beginners fall into this trap",
                data: "It isn't your job to keep other players honest! Don't call just in case they’re bluffing. Stay focused on the fundamentals."

            }, {
                image: '10.png',
                dataHeader: 'Not Putting Opponents on Hands',
                data: "Try to work out what your opponent has. Most beginners don't even attempt this - and it is a vital part of the game. See our fundamentals course for a detailed lesson on this."

            }]


    },
    successfull: {
        header: "What makes a successful Poker Player?",
        imagePath: "/images/pokerSuccess/",
        images: ['1.png', '2.png', '3.png', '4.png', '5.png', '6.png', '7.png'],
        imagesAndData: [
            {
                image: '1.png',
                dataHeader: 'Deception and Observation',
                data: "Almost all winning players watch what their opponents do, the number of hands they play, style & betting patterns."

            }, {
                image: '2.png',
                dataHeader: 'They play at the right level',
                data: "Don’t play too high & choose their opponents. $ won against bad players are worth EXACTLY the same as $ won from poker geniuses!"

            }, {
                image: '3.png',
                dataHeader: 'Bankroll Management.',
                data: "They operate tight bankroll management."

            }, {
                image: '4.png',
                dataHeader: 'Controll',
                data: "They are in control. Be the one betting not the one calling, aggression is a key ingredient in winning poker players. Think about position & starting hands."

            }, {
                image: '5.png',
                dataHeader: 'Remain Unpredictable',
                data: "They balance their play to remain unpredictable. Deceiving your opponent as to the strength of your hands is a key element in poker. Balancing scenarios will allow you to bluff more successfully and get paid on your bigger hands."

            }, {
                image: '6.png',
                dataHeader: 'Long Term Thinking',
                data: "They Think Long Term. Most losing players only think as far as the next game or two and make short term decisions. Winning players look longer, they recognise that luck plays a big part short term but over time better players will win."

            }, {
                image: '7.png',
                dataHeader: 'Unclear Why they are Betting',
                data: "They play, analyse & learn. Virtually every good player reviews their sessions (Poker Whiz will let you do this). They review longer term too - to spot their subtler leaks. (Use Report Cards and the Clinic Topics to do this)."
            }]
    }
}

export const MeetWhiz = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    return (<div className="base_home_whiz">
        <div className="base_home_whiz_img_div">
            <img className="base_home_whiz_img" src={props.imageUrl} />
        </div>
        <div className="base_home_whiz_description_div">
            <div className="base_home_whiz_header">Hey {localStorage.getItem("first_name")}! I’m Whiz </div>
            <div className="base_home_whiz_description">
                My in-game analysis & live hand feed are going to take your game to the next level!
    </div>
            <button className="base_home_whiz_meet_button" onClick={() => { props.onMGLClick() }}
                style={{
                    backgroundColor: themeColor,
                    color: themeTextColor,
                }}
            >
                <span data-e2e="meet whiz">
                    Meet Whiz
        </span>
            </button>
        </div>
    </div>)
}

export const LearnMoreModal = (props) => {
    const themeColor = getColor()
    const imageObj = images[`${props.learnMoreType}`];
    const showImage = imageObj ? imageObj.imagesAndData[props.count - 1] : false;
    return <div id="learnMoreModal" className="modal fade" role="dialog">
        <div className="modal-dialog learnMore_ModalDialog">
            {showImage &&
                <div className="modal-content learn_more_modal_content" >
                    <div className="modal-header learn_more_modal_header">
                        <button type="button" className="close" data-dismiss="modal" onClick={props.reset}><i className="fa fa-lg fa-times" data-e2e="close"></i></button>
                        <h4 className="modal-title">{imageObj.header}</h4>
                    </div>
                    <div className="modal-body learn-more-modal-body">
                        <img src={`${baseUrl}${imageObj.imagePath}${showImage.image}`} />
                        <div className="learn-more-image-data">
                            <span className="learn-more-image-data-header">
                                {showImage.dataHeader}
                            </span>
                            <span className="learn-more-image-data-desc">
                                {showImage.data}
                            </span>
                        </div>
                    </div>
                    <div className="modal-footer-nex-prev">
                        <span className={" prevLearnMoreLand"} onClick={props.prev}>
                            <i data-e2e="left" className={"fa fa-lg fa-arrow-left " + (props.count > 1 ? 'button-active' : '')}
                            style={props.count > 1 ? {
                                color: themeColor
                            } : {}}
                            />
                        </span>
                        <span className={"nextLearnMoreLand"} onClick={() => props.next(imageObj.imagesAndData.length)}>
                            <i data-e2e="right" className={"fa fa-lg fa-arrow-right " + (props.count < imageObj.imagesAndData.length ? 'button-active' : '')}
                            style={props.count < imageObj.imagesAndData.length ? {
                                color: themeColor
                            } : {}}
                            />
                        </span>
                        {/* <button type="button" className="btn btn-default" data-dismiss="modal">Close</button> */}
                    </div>
                </div>}

        </div>
    </div>
}
const learnMoreObj = [{
    header: " What are the most common poker mistakes ?",
    data: "Click here to learn about some of the most common poker mistakes.",
    action: 'mistake',
    dataToggle: true,
},
{
    header: "What makes a successfull poker player  ?",
    data: "Click here to learn the key habits of professional poker players.",
    action: 'successfull',
    dataToggle: true,
}, 
// {
//     header: "Deep dive in to our free poker courses!",
//     data: "Check out our courses to learn more about the game of poker. ",
//     action: 'courses',
//     dataToggle: false,
// }, 
{
    className:'quiz-launch',
    className2:'quiz-launch-play',
    header: "Want to play a quick quiz?",
    data: "It'll help improve your game!",
    action: 'quiz',
    showButton: true,
    imageUrl: "//" + domain + "/images"
    
}]
const learnMoreObjSpin = [{
    header: " What are the most common poker mistakes ?",
    data: "Click here to learn about some of the most common poker mistakes.",
    action: 'mistake',
    dataToggle: true,
},
{
    header: "What makes a successfull poker player  ?",
    data: "Click here to learn the key habits of professional poker players.",
    action: 'successfull',
    dataToggle: true,
}, 
// {
//     header: "Deep dive in to our free poker courses!",
//     data: "Check out our courses to learn more about the game of poker. ",
//     action: 'courses',
//     dataToggle: false,
// }, 
]
export const LearnMoreHome = (props) => {
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    let learnMoreList = props.gameType === "spin" ? learnMoreObjSpin :learnMoreObj;
    return (<div className="base_home_learn_more">
        <div className="base_home_learn_more_header">
            Want Learn More?
        </div>
        <LearnMoreModal
            count={props.count}
            learnMoreType={props.learnMoreType} prev={props.prev}
            next={props.next}
            reset={props.reset} />
        <QuickQuiz history={props.history}/>
        {learnMoreList.map((item, i) => {
            return  <div key={i} className={"base_home_learn_more_description_div "+item.className}
                onClick={() => { 
                    props.onClickHandler(item.action);
                    if (item.dataToggle) {
                        let track = {}
                        track.hit_page = 'HomePage';
                        track.hit_type = 'LearnMore';
                        track.hit_attribute1 = props.gameType;
                        track.hit_attribute2 = item.header;
                        saveActivity(track);
                    }
                 }}
                data-toggle={item.dataToggle ? "modal" : ''} data-target={item.dataToggle ? "#learnMoreModal" : ''} >
                {item.imageUrl && <div>
                    {(partyBrands.includes(localStorage.getItem('loggedInType')) ) ?
                    <img className="quiz-icon" src={item.imageUrl+'/LandingPage/Whiz_Helmet.png'} />:
                    <img className="quiz-icon" src={item.imageUrl+'/LandingPage/Whiz_Helmet_generic.png'} />}
                </div>}
                <div className="base_home_learn_more_description" style={item.action === 'quiz' ? {flex:1} : {}}>
                    <span className="base_home_learn_more_des_header" data-e2e={item.header}>
                        {item.header}
                    </span>
                    <span className="base_home_learn_more_des_content" data-e2e={item.data}>
                        {item.data}
                    </span>
                </div>
                {item.showButton ? 
                    <span className={item.className2}>
                        <button
                            className="partyPokerPlayBtn"
                            style={{ width: '120px' }}
                            data-toggle="modal" data-target="#quizModal"
                            onClick={props.handleQuizOpen}
                            style={{
                                backgroundColor: themeColor,
                                color: themeTextColor,
                            }}
                            >
                            Play Now!
                        </button>
                    </span>
                    :
                    <span className="right_chevron_span">
                        <i className="fa fa-lg fa-chevron-right" data-e2e={item.data} 
                            style={{
                                color: themeColor,
                            }}
                        ></i>
                    </span>
                }
            </div>
        })}

    </div>)
}


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/commonComponents.js
 **/